module.exports = __webpack_public_path__ + "img/8-reach-mountain_v8e_loading.d38e84d4.jpg";